import {
  AgenticApplicantFilter,
  AgenticCompetencyType,
  AgenticConfidence,
  AgenticRecommendation,
  AgenticVerdict,
} from '../../../../utils/types/agentic_assessment_types';

export const AGENTIC_PANELS = ['Setup', 'Candidates', 'Results'] as const;
export type AgenticPanel = typeof AGENTIC_PANELS[number];

export const LEVEL_NAMES: Record<number, string> = {
  1: 'Aware',
  2: 'Follows',
  3: 'Adapts',
  4: 'Handles exceptions',
  5: 'Shapes',
};

export const LEVEL_HINTS: Record<number, string> = {
  1: 'Can describe it. Textbook knowledge.',
  2: 'Does it in a standard situation.',
  3: 'Explains why, adjusts to the situation, weighs options.',
  4: 'Spots problems, recovers, makes sound calls under pressure.',
  5: 'Improves the process, teaches, sets standards.',
};

export const COMPETENCY_TYPES: { value: AgenticCompetencyType; label: string; hint: string }[] = [
  { value: 'knowledge', label: 'Knowledge', hint: 'Facts, rules, domain concepts' },
  { value: 'procedure', label: 'Procedure', hint: 'Carrying out a known process' },
  { value: 'judgment', label: 'Judgment', hint: 'Decisions under competing pressures' },
  { value: 'interpersonal', label: 'Interpersonal', hint: 'Customers, patients, colleagues' },
  { value: 'experience', label: 'Experience', hint: 'Past track record and ownership' },
];

export const APPLICANT_FILTERS: AgenticApplicantFilter[] = ['Assigned', 'Invite Sent', 'In Progress', 'Completed', 'Expired'];

export const STATUS_CHIP: Record<AgenticApplicantFilter, string> = {
  Assigned: 'bg-slate-100 text-slate-600',
  'Invite Sent': 'bg-sky-50 text-sky-700',
  'In Progress': 'bg-amber-50 text-amber-700',
  Completed: 'bg-emerald-50 text-emerald-700',
  Expired: 'bg-rose-50 text-rose-700',
};

export const RECOMMENDATION_CHIP: Record<AgenticRecommendation, string> = {
  'Strong yes': 'bg-emerald-600 text-white',
  Proceed: 'bg-emerald-50 text-emerald-700',
  'Borderline, review': 'bg-amber-50 text-amber-700',
  'Do not proceed': 'bg-rose-50 text-rose-700',
};

export const VERDICT_MARK: Record<AgenticVerdict, { mark: string; className: string }> = {
  pass: { mark: '✓', className: 'text-emerald-600' },
  partial: { mark: '~', className: 'text-amber-600' },
  fail: { mark: '✗', className: 'text-rose-600' },
};

export const CONFIDENCE_LABEL: Record<AgenticConfidence, string> = {
  none: 'Not reached',
  low: 'Low confidence',
  medium: 'Medium confidence',
  high: 'High confidence',
};

export const formatDate = (epochSeconds?: number | null): string =>
  epochSeconds ? new Date(epochSeconds * 1000).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

export const fullName = (first?: string, last?: string): string =>
  [first, last].filter(Boolean).join(' ') || 'Unnamed candidate';
